import http from '@/services/http';

export interface ApiAuthUser {
  id: string;
  name: string;
  email: string;
  role: string;
  team: string | null;
  active: boolean;
  status: string;
  last_login_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user: ApiAuthUser;
}

export async function login(payload: { username: string; password: string }) {
  const response = await http.post<LoginResponse>('/api/auth/login', payload);
  return response.data;
}

export async function refreshToken(payload: { refresh_token: string }) {
  const response = await http.post<LoginResponse>('/api/auth/refresh', payload);
  return response.data;
}
